import { render, staticRenderFns } from "./NewsOne.vue?vue&type=template&id=7ad83392&scoped=true"
import script from "./NewsOne.vue?vue&type=script&lang=js"
export * from "./NewsOne.vue?vue&type=script&lang=js"
import style0 from "./NewsOne.vue?vue&type=style&index=0&id=7ad83392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad83392",
  null
  
)

export default component.exports